@if (!isMobile()) {
  <proffeo-ui-card class="task-details-subtasks-card w-full">
    <mat-accordion class="w-full">
      <mat-expansion-panel
        (expandedChange)="desktopPanelExpandedChange.emit($event)"
        [expanded]="showTaskSubtasksPanel()"
        class="task-details-subtasks-panel"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="min-w-0">
            <div class="flex w-full min-w-0 justify-between items-center">
              <p class="truncate text-xl">
                {{ 'tasks-list-name-column-show-subtasks' | translate }} ({{ task().subtasksCount ?? 0 }})
              </p>
            </div>
          </mat-panel-title>
          <div class="flex justify-center px-4">
            <proffeo-ui-button
              (clicked)="addSubtaskFromPanel.emit($event)"
              [text]="'task-menu.add-subtask'"
              variant="accent"
              fontIcon="add"
              class="pr-3"
            />
          </div>
        </mat-expansion-panel-header>
        <div class="flex w-full flex-col gap-2 !p-0">
          <div class="task-details-subtasks-list flex w-full flex-col gap-2.5 px-4 pb-4">
            @for (subTask of subtasks(); track $index) {
              <div class="flex w-full items-center gap-0">
                <div class="flex shrink-0 items-center justify-center">
                  <mat-icon
                    fontIcon="subdirectory_arrow_right"
                    class="opacity-50 icon-sm"
                  />
                </div>
                <proffeo-task-details-subtask-item
                  (click)="subtaskClick.emit(subTask); $event.stopPropagation()"
                  (addTimeReport)="addTimeReport.emit($event)"
                  (priorityChanged)="priorityChanged.emit({ priority: $event, subtask: subTask })"
                  (percentageChange)="progressChanged.emit({ percentage: $event, subtask: subTask })"
                  (statusChanged)="statusChanged.emit({ status: $event, subtask: subTask })"
                  [subTask]="subTask"
                  class="min-w-0 flex-1 cursor-pointer"
                />
              </div>
            }
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </proffeo-ui-card>
} @else {
  <proffeo-ui-card
    [class.hidden]="!isTaskSubtasksPanelContentVisible()"
    density="compact"
  >
    <div class="flex w-full flex-col gap-2.5">
      @for (subTask of subtasks(); track $index) {
        <div class="flex w-full items-center gap-0">
          <div class="ml-[5px] flex shrink-0 items-center justify-center">
            <mat-icon
              fontIcon="subdirectory_arrow_right"
              class="opacity-50 icon-sm"
            />
          </div>
          <proffeo-task-details-subtask-item
            (click)="subtaskClick.emit(subTask); $event.stopPropagation()"
            (addTimeReport)="addTimeReport.emit($event)"
            (priorityChanged)="priorityChanged.emit({ priority: $event, subtask: subTask })"
            (percentageChange)="progressChanged.emit({ percentage: $event, subtask: subTask })"
            (statusChanged)="statusChanged.emit({ status: $event, subtask: subTask })"
            [subTask]="subTask"
            class="mr-[5px] min-w-0 flex-1 cursor-pointer"
          />
        </div>
      }
    </div>
  </proffeo-ui-card>
}
